import style from  "./ErrorMod.module.css";

import image from "../../data/img/error.png"
export default function ErrorMod({ idp }) {
    const homepage = `${window.location.origin}/?IDP=${idp}`
    return (
        <div className={style.wrapperMain}>
            <div>
                <h1 className="titolo">Errore Pagamento</h1>
                <p>Siamo spiancenti, il pagamento non è andato a buon fine.</p>
                <a href="/"><button className={style.Btn}>Torna agli acquisti</button></a>
            </div>
            <div>
                <a href={homepage}> 
                <img alt="err img"className={style.img} src={image}  /></a>
            </div>
        </div>
    )
}